import type { ReactNode } from 'react';
import { usePermission } from '@/hooks/use-permission';

type CanProps = {
  /** Required permission, e.g. "finance.invoice.approve". */
  permission?: string;
  /** Or any one of these. */
  anyOf?: string[];
  /** Or all of these. */
  allOf?: string[];
  children: ReactNode;
  /** Rendered instead when the check fails. Usually nothing. */
  fallback?: ReactNode;
};

/**
 * Gates a privileged control (spec §4.3). The server re-checks the same
 * permission on every request — this only keeps the UI honest about what the
 * user can actually do.
 */
export function Can({ permission, anyOf, allOf, children, fallback = null }: CanProps) {
  const { can, canAny, canAll } = usePermission();

  const allowed =
    (permission ? can(permission) : true) &&
    (anyOf ? canAny(...anyOf) : true) &&
    (allOf ? canAll(...allOf) : true);

  return <>{allowed ? children : fallback}</>;
}
